import { Link } from "react-router-dom";
import { Tablet, BookOpen, Download, ArrowRight, Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CatalogueTeaser = () => {
  return (
    <section
      id="catalogue"
      data-testid="catalogue-teaser"
      className="py-20 sm:py-28 bg-primary text-primary-foreground relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-15">
        <div className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, white 0%, transparent 35%), radial-gradient(circle at 80% 70%, white 0%, transparent 35%)",
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur px-4 py-1.5 rounded-full text-sm font-medium mb-5 border border-white/20">
            <Tablet className="w-4 h-4" />
            Built for the field
          </div>

          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            Digital Catalogue for
            <br />
            Medical Representatives.
          </h2>

          <p className="mt-5 text-base sm:text-lg text-white/85 leading-relaxed max-w-xl">
            Open the catalogue on any tablet or phone and walk doctors through every
            Pediarange product — full-screen brochures, swipeable navigation, and
            instant PDF download for handouts.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-3 max-w-2xl">
            {[
              { icon: BookOpen, label: "Full brochure view" },
              { icon: Maximize2, label: "Tablet-optimised" },
              { icon: Download, label: "Download / share" },
            ].map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="bg-white/10 backdrop-blur border border-white/15 rounded-2xl p-4"
              >
                <Icon className="w-5 h-5 mb-2" />
                <p className="text-sm font-medium">{label}</p>
              </div>
            ))}
          </div>

          <div className="mt-9 flex flex-wrap gap-3">
            <Link to="/catalogue" data-testid="open-catalogue-cta">
              <Button
                size="lg"
                className="rounded-full bg-white text-primary hover:bg-white/90 h-12 px-7 font-semibold"
              >
                Launch Catalogue
                <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="relative">
          <div className="relative mx-auto max-w-md">
            {/* Tablet frame */}
            <div className="bg-foreground/30 backdrop-blur rounded-[40px] p-3 border border-white/20 soft-shadow">
              <div className="bg-white rounded-[28px] aspect-[3/4] overflow-hidden flex flex-col">
                <div className="px-5 pt-5 pb-3 flex items-center justify-between border-b border-border">
                  <p className="font-heading font-bold text-foreground text-sm">
                    Pediarange Catalogue
                  </p>
                  <span className="text-[10px] text-muted-foreground">1 / 3</span>
                </div>
                <div className="flex-1 bg-secondary p-5 flex items-center justify-center">
                  <img
                    src="https://customer-assets.emergentagent.com/job_886a0688-f451-4441-8599-1e4b0ded5080/artifacts/vaj23wg4_SUN%20POP%20.jpeg"
                    alt="SUNPOP Plus brochure"
                    className="max-h-full max-w-full object-contain rounded-xl shadow-md"
                  />
                </div>
                <div className="px-5 py-3 flex items-center justify-between bg-white">
                  <span className="text-xs text-muted-foreground">Swipe →</span>
                  <span className="text-xs font-semibold text-primary">SUNPOP Plus</span>
                </div>
              </div>
            </div>
            <div className="absolute -top-4 -right-4 bg-accent text-accent-foreground rounded-full px-4 py-2 font-heading font-bold text-sm shadow-lg animate-float-slow">
              Live demo
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CatalogueTeaser;
